import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import Text from '@redbubble/design-system/react/Text';
import PropTypes from 'prop-types';
import FeedGrid from '../Feed/FeedGrid';
import styles from './RelatedWorks.css';
import { withFeatureToggle } from '../../contexts/FeatureToggle';
import { withExperimentContext } from '../../contexts/Experiment';
import withRelatedWorks from '../../containers/apollo/withRelatedWorks';
import { analyticsPayload } from '../../lib/analytics';
import messages from './messages';

const MoreLikeThis = compose(
  withFeatureToggle,
  withExperimentContext,
  withRelatedWorks
)(FeedGrid);

MoreLikeThis.displayName = FeedGrid.displayName;

// eslint-disable-next-line react/prefer-stateless-function
export class RelatedWorks extends Component {
  render() {
    const { workId, analyticsLabel, logEvent, userInfo } = this.props;

    const logComponentInView = (componentName, loading) => () => {
      logEvent({
        analytics: analyticsPayload.componentShowedInExplorePage(
          componentName,
          loading
        )
      });
    };

    return (
      <div className={styles.gridContainer}>
        <Text type="display2" element="h2" block>
          <FormattedMessage {...messages.RelatedWorks} />
        </Text>
        <MoreLikeThis
          userInfo={userInfo}
          key={workId}
          workId={workId}
          analyticsLabel={analyticsLabel}
          onLoadingShowed={logComponentInView('explore-more-like-this', true)}
          onContentShowed={logComponentInView('explore-more-like-this', false)}
        />
      </div>
    );
  }
}

RelatedWorks.displayName = 'RelatedWorks';

RelatedWorks.propTypes = {
  workId: PropTypes.string.isRequired,
  logEvent: PropTypes.func
};

RelatedWorks.defaultProps = {
  logEvent: () => {}
};

export default RelatedWorks;
